import { render, staticRenderFns } from "./oilOrderList.vue?vue&type=template&id=d5285120&scoped=true"
import script from "./oilOrderList.vue?vue&type=script&lang=js"
export * from "./oilOrderList.vue?vue&type=script&lang=js"
import style0 from "./oilOrderList.vue?vue&type=style&index=0&id=d5285120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5285120",
  null
  
)

export default component.exports